import React from "react";
import { inject, observer } from "mobx-react";
import { observable } from "mobx";

import { IManagementStore } from "Stores/Management/types";
import LocationsContent from "./LocationsContent/LocationsContent";
import { Values } from "@src/Tools/Values";
import { IAuthStore } from "@src/Stores/Auth/types";
import { IValuesStore } from "@src/Stores/Values/types";

interface IProps {
  management?: IManagementStore;
  auth?: IAuthStore;
  values?: IValuesStore;
}

@inject("auth", "values", "management")
@observer
class ManageLocations extends React.Component<IProps> {
  @observable isLoading: boolean = true;

  async componentDidMount() {
    const { management, auth, values } = this.props;
    try {
      await Promise.all([management.getLocations(), management.getActivePositions()]);
        if (auth.user.roles.find(x => x == values.roles.Administrator) != null) {
        await management.getDeletedLocations();
      }
      this.isLoading = false;
      document.title = Values.getLocalizationValue("locations");
    } catch (error) {
      console.error(error);
    }
  }
  render() {
    return <React.Fragment>{this.isLoading ? <div /> : <LocationsContent />}</React.Fragment>;
  }
}

export default ManageLocations;
